/**
 * FrictionCounterMove — side-by-side panel pair with chunky navy outer border
 * and colored top stripes (coral for friction, steel for counter-move).
 *
 * Used in dyadic Blueprint surfaces (Pre-Meeting, Relational, parts of
 * Resume) to render a friction → counter-move pair tightly bound visually.
 *
 * Per /design/mockups/Phase1_Brand_Demonstrator_v10.html: 2px navy outer
 * border, 4px coral / steel top stripes, very-soft tint backgrounds that
 * print at near-zero ink.
 */

export default function FrictionCounterMove({ friction, counterMove }) {
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: 16,
        marginTop: 16,
        marginBottom: 24,
      }}
      data-component="FrictionCounterMove"
    >
      <div
        style={{
          background: "var(--ppr-color-background-surface)",
          padding: "18px 20px",
          border: "1px solid var(--ppr-color-border-default)",
          borderLeft: "2px solid var(--ppr-color-accent-coral)",
        }}
        data-panel="friction"
      >
        <div
          style={{
            fontFamily: "var(--ppr-typography-font-family-ui)",
            fontSize: "11px",
            letterSpacing: "0.14em",
            textTransform: "uppercase",
            color: "var(--ppr-color-accent-coral)",
            marginBottom: 9,
          }}
        >
          Likely friction
        </div>
        <div
          style={{
            fontFamily: "var(--ppr-typography-font-family-body)",
            fontSize: "15px",
            lineHeight: "var(--ppr-typography-line-height-loose)",
            color: "var(--ppr-color-text-primary)",
          }}
        >
          {friction}
        </div>
      </div>
      <div
        style={{
          background: "var(--ppr-color-background-surface)",
          padding: "18px 20px",
          border: "1px solid var(--ppr-color-border-default)",
          borderLeft: "2px solid var(--ppr-color-text-primary)",
        }}
        data-panel="counter-move"
      >
        <div
          style={{
            fontFamily: "var(--ppr-typography-font-family-ui)",
            fontSize: "11px",
            letterSpacing: "0.14em",
            textTransform: "uppercase",
            color: "var(--ppr-color-text-primary)",
            marginBottom: 9,
          }}
        >
          Counter-move
        </div>
        <div
          style={{
            fontFamily: "var(--ppr-typography-font-family-body)",
            fontSize: "15px",
            lineHeight: "var(--ppr-typography-line-height-loose)",
            color: "var(--ppr-color-text-primary)",
          }}
        >
          {counterMove}
        </div>
      </div>
    </div>
  );
}
